import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import Action from "../../components/Action";
import Card from "../../components/DashboardCard";
import TextQuestion from "../../components/TextQuestion";

const Postal2FACodeInput = ({ doableID, codeValidated }) => {
  const [code, setCode] = useState("");
  const [validationError, setValidationError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const validateCode = async () => {
    if (!code) {
      setValidationError("Please enter a code");
      return;
    }
    setLoading(true);
    try {
      const resp = await fetch(`/api/dashboard/doable/${doableID}/validate-2fa-code`, {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({
          postal_2fa_code: code,
        }),
      });
      if (!resp.ok) {
        const body = await resp.text();
        throw new Error(`Non-success response: ${resp.status} ${resp.statusText}. ${body}`);
      }
      const data = await resp.json();
      if (data.postal_2fa_code_valid === true) {
        codeValidated(code);
      } else {
        setValidationError("We don’t recognise that code. Please try again.");
        setLoading(false);
      }
    } catch (err) {
      setError(true);
      setLoading(false);
      Sentry.captureException(err, { tags: { action: "ValidatePostal2FACode" } });
    }
  };

  if (error) {
    return (
      <Card title="Sorry, that didn’t work" removeTopPadding>
        <p>We’re having trouble validating your code at the moment. Please try again later.</p>
        <p>If you continue to have problems, let us know using webchat</p>
      </Card>
    );
  }

  return (
    <Card title="Please enter your Juno authentication code">
      <p>
        As you’re about to give us sensitive information, we need you to enter the authentication code we sent you in
        the post.
      </p>

      <p>This is to confirm it’s really you, and will keep your information secure.</p>

      <TextQuestion
        question="Enter your Juno authentication code"
        value={code}
        valueEntered={setCode}
        disabled={loading}
        validationError={validationError}
      />

      <p>If you need a reminder of your code posted to you, ask us via webchat.</p>

      <Action disabled={loading} onClick={validateCode}>
        Continue
      </Action>
    </Card>
  );
};

export default Postal2FACodeInput;
